import { Fragment,useState,useEffect,useContext } from 'react'
import { Form, Button, Container, Row,Col} from 'react-bootstrap'
import { Navigate, useNavigate } from 'react-router-dom';
import UserContext from '../UserContext';
import Swal from 'sweetalert2';



export default function Register() {




  const navigate = useNavigate();
  const {user} = useContext(UserContext);
  
  //state hook
  
  const[email, setEmail] = useState(""); 
  const [password,setPassword] = useState("");
  const [password2,setPassword2] = useState("");

  
  //state to determine whether submit button is enable or not
  const [isActive, setIsActive] = useState(false);


//Check if values are successfully passed
//   console.log(`firstName: ${firstName}`);
//   console.log(`lastName: ${lastName}`);
//   console.log(`mobileNumber: ${mobileNo}`);
//   console.log(`Email: ${email}`);
//   console.log(`Password1: ${password}`);
//   console.log(`Password2: ${password2}`);
     console.log(email);
	   console.log(password);
     console.log(password2);



  function registerUser(e) {
   
    
    e.preventDefault();

    //doesnot exist routes in backend checkEmail
		fetch(`${process.env.REACT_APP_API_URL}users/checkEmail`, {
			method: 'POST',
			headers: {
				'Content-Type' : 'application/json',
			},
			body: JSON.stringify({
				email: email
			})

		})
		.then(res => res.json())
		.then(data => {
			console.log(data);
			if(data){
				Swal.fire({
					title: "Duplicate email found",
					icon: "info",
					text: "The email that you're trying to register already exist"
				})
			} else {
				fetch(`${process.env.REACT_APP_API_URL}users/register`,{
					method: 'POST',
					headers: {
						'Content-Type' : 'application/json',
					},
					body: JSON.stringify({
	
						email: email,
						password: password
					})
				})
				.then(res => res.json())
				.then(data => {
					console.log(data);

					if(data === true){
						Swal.fire({
							title: 'Registration Successful!',
							icon: 'success',
							text: 'Thank you for registering'
						})

            // clear input fields
               
                setEmail('');
                setPassword('');
                setPassword2('');

							navigate('/login')
					} else {
						Swal.fire({
							title: 'Registration failed',
							icon: 'error',
							text: 'Something went wrong, try again'
						})
					}
				})
			}
		})

		

		

		//alert('Thank you for registering');
	};

    
    

  



  //useEffect for button
  useEffect(() => {
    
    if(( email !== '' && password !== '' && password2 !== '') && (  password === password2)){
        setIsActive(true);
    } else {
        setIsActive(false);
    }
}, [email, password, password2]);


  
  
  
  
    return (
      (user.id !== null) ?
      <Navigate to="/product"/>
  
      :
    <Fragment >

    <h1 className='text-center mt-3'>REGISTER</h1>
    <Container className="container-reg-form p-3 mt-5" style={{width:"450px"}}>
    <Form className="reg-form" onSubmit={(e) => {registerUser(e)}}>






      <Form.Group className=" text-center mb-3" controlId="userEmail">
        <Form.Label className='text-light'>Email address</Form.Label>
        <Form.Control
					type="email"
                    value = {email}
					placeholder="Enter your email here"
					onChange = {(e) => {setEmail(e.target.value)}}
                    required
				/>

      
      </Form.Group>

      <Form.Group className=" text-center mb-3" controlId="password">
        <Form.Label className='text-light'>Password</Form.Label>
        <Form.Control
					type="password"
                    value = {password}
					placeholder="Enter your Password"
					onChange = {(e) => {setPassword(e.target.value)}}
                    required
				/>
      </Form.Group>

      <Form.Group className=" text-center mb-3" controlId="password2">
        <Form.Label className='text-light'>Verify Password</Form.Label>
        <Form.Control
					type="password"
                    value = {password2}
					placeholder="Enter your Password Again"
					onChange = {(e) => {setPassword2(e.target.value)}}
                    required
				/>
      </Form.Group> 
      <Container fluid >
      <Row>
      <Col align="center">
      { isActive ?
        <Button className="button-form" variant="success"  type='submit' id='submitBtn' >
        Register
      </Button>
        :
        <Button className="button-form" variant="secondary" type='submit' id='submitBtn' disabled>
        Register
      </Button>

    }
   {/*   { isActive ?
        <Button className="" variant="success" type='submit' id='submitBtn'  >
        Submit
      </Button>
        :
        <Button variant="primary" type='submit' id='submitBtn'  disabled>
        Submit
      </Button>

    } */}
    </Col>
    </Row>
    </Container>
    </Form>
    </Container>
    </Fragment>
  )
}

